import styles from "./LoadingSpinner.module.css";

export default function LoadingSpinner() {
  return (
    <div className={styles.body}>
      <div className={styles.container}>
        <svg className={styles.viewBox} viewBox="25 25 50 50">
          <circle className={styles.circle} r="20" cy="50" cx="50"></circle>
        </svg>
      </div>
    </div>
  );
}
